import { render, staticRenderFns } from "./ResultHeaderItem.vue?vue&type=template&id=2eb7b493"
import script from "./ResultHeaderItem.vue?vue&type=script&lang=js"
export * from "./ResultHeaderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb7b493')) {
      api.createRecord('2eb7b493', component.options)
    } else {
      api.reload('2eb7b493', component.options)
    }
    module.hot.accept("./ResultHeaderItem.vue?vue&type=template&id=2eb7b493", function () {
      api.rerender('2eb7b493', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/budget/components/ResultHeaderItem.vue"
export default component.exports